module.exports = __webpack_public_path__ + "img/champion-floating-cn.5c077914.gif";